const adminCardRouter = [
  {
    path: '/admin/card',
    name: 'AdminCardIndex',
    component: () => import('@/views/admin/card/index')
  },
  {
    path: '/admin/card/stat',
    name: 'AdminCardStat',
    component: () => import('@/views/admin/card/stat')
  }
]

export default adminCardRouter



// WEBPACK FOOTER //
// ./src/router/modules/admin/card.js